export const parserTarjeta = ({
  _id, nombre, posicionesEnTrama, elemento
}) => ({
  _id,
  nombre,
  posicionesEnTrama,
  elemento: elemento && elemento.nombre,
});
